import { render } from "./GenericTableWithApi.vue?vue&type=template&id=31ca1284&ts=true"
import script from "./GenericTableWithApi.vue?vue&type=script&lang=ts"
export * from "./GenericTableWithApi.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__